<template>
    <v-main class="lyt-container pt-3 justify-center custom-main">
        <v-container>
            <v-row class="d-flex justify-center white--text">
                <h1>
                    <i class="fas fa-file-invoice"></i> Votos por dispositivo
                </h1>
            </v-row>
            <v-row class="d-flex justify-center mt-4 table-admins">
                <v-data-table
                    :headers="headers"
                    :items="votesDevice"
                    :items-per-page="perPage"
                    :page.sync="currentPage"
                    :search="search"
                    class="datatable-admins"
                    @page-count="pageCount = $event"
                >
                    <template v-slot:top>
                        <v-select
                            v-model="electionIdSelected"
                            :item-text="textItemElection"
                            :items="elecciones"
                            :loading="isLoading"
                            class="mx-4"
                            item-value="id"
                            label="Selecciona elección"
                            @change="onChangeElection"
                        >
                        </v-select>
                        <v-text-field
                            v-model="search"
                            class="mx-4"
                            label="Buscar"
                        >
                            <template v-slot:append-outer>
                                <v-btn
                                    :disabled="isLoading || !electionIdSelected"
                                    :loading="isLoading"
                                    @click="onChangeElection"
                                >
                                    <i
                                        :class="{ isLoading: 'fa-spin' }"
                                        class="fa fa-sync"
                                    ></i>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </template>
                </v-data-table>
            </v-row>

            <v-row></v-row>
        </v-container>
    </v-main>
</template>
<script>
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { mapGetters, mapActions } from 'vuex';

import { DateTime } from 'luxon';

export default {
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
        }),
    },
    components: {
        ScaleLoader,
    },
    data() {
        return {
            headers: [
                {
                    text: 'Código',
                    value: 'codigo',
                },
                {
                    text: 'UUID',
                    value: 'device_uuid',
                },
                {
                    text: 'Modelo',
                    value: 'device_name',
                },
                {
                    text: 'Tipo de Usuario',
                    value: 'type_user',
                },
                {
                    text: 'OCG',
                    value: 'ocg',
                },
                {
                    text: 'Fecha',
                    value: 'created_at',
                },
            ],
            votesDevice: [],
            search: '',
            perPage: 10,
            currentPage: 1,
            pageCount: 0,
            electionIdSelected: '',
            isLoading: true,
        };
    },
    methods: {
        ...mapActions({
            _getElecciones: 'elecciones/getElecciones',
            _getVotesDevice: 'funcionarios/getVotesDevice',
        }),
        onChangeElection() {
            this.loadVotesDevice();
        },
        buildParams() {
            return {
                election_id: this.electionIdSelected,
                skip: (this.currentPage - 1) * this.perPage,
                limit: this.perPage,
                search: this.search,
            };
        },
        loadVotesDevice() {
            this.votesDevice = [];

            if (!this.electionIdSelected) {
                return;
            }

            this.isLoading = true;
            this._getVotesDevice(this.electionIdSelected)
                .then(res => {
                    if (res.data) {
                        console.log('res.data', res.data);
                        this.votesDevice = res.data.map(vote => {
                            vote.created_at = DateTime.fromISO(vote.created_at)
                                .setZone('America/Mexico_City')
                                .toLocaleString(DateTime.DATETIME_SHORT);
                            return vote;
                        });

                        console.log('this.votesDevice', this.votesDevice);
                    }
                })
                .catch(error => {
                    console.error(error);
                })
                .finally(_ => {
                    this.isLoading = false;
                });
        },
        textItemElection: item =>
            `${item.id} | ${item.description} | ${item.type.toUpperCase()}`,
    },
    created() {
        this._getElecciones();
        this.isLoading = false;
    },
};
</script>
<style lang="scss">
.lyt-container {
    background-image: url('../assets/bg_udg.png');
    background-color: $votex-background-primary;
}

.table-admins {
    margin-bottom: 100px;

    .datatable-admins {
        width: 100%;
    }
}
</style>
